import Vue from 'vue';
import store from '@/store/index.js'

let _ = require("lodash");
/*
*  使用方法
*  将以下代码复制到一个js文件中，然后在入口文件main.js中import引入即可；
*  给elementUI的dialog上加上 v-dialogDrag 指令就可以实现弹窗的全屏和拉伸了。
*  给dialog设置 :close-on-click-modal="false" , 禁止点击遮罩层关闭弹出层
*  如果是form表单，不要将提交等按钮放置el-form-item，以免在上下拉伸时被隐藏
*/

// v-dialogDrag: 弹窗拖拽+水平方向伸缩
//当前位置
let nowLeft = 0;
let nowTop = 0;

Vue.directive('dialogDrag', {
    update(el, binding, vnode, oldVnode) {
        //弹框可拉伸最小宽高
        let minWidth = 800;
        let minHeight = 600;
        let minMingxiHeight = 400;  //明细区域原始高度

        //弹框变化高度
        let offsetHeight = 0;

        //初始非全屏
        let isFullScreen = false;

        //当前宽高
        let nowWidth = 0;
        let nowHight = 0;

        //原始宽高
        let beginWidth = 0;
        let beginHeight = 0;


        //当前顶部高度
        let nowMarginTop = 0;

        //获取弹框头部（这部分可双击全屏）
        let dialogHeaderEl = el.querySelector('.el-dialog__header');

        //弹窗
        let dragDom = el.querySelector('.el-dialog');


        if(!dragDom)
        {
          dragDom=document.querySelector('#' + binding.value + ' .el-dialog');  //如果是嵌套的dialog，添加了append-to-body属性，给dialog添加id为newDialog2，以通过id来获取dialog对象

          dialogHeaderEl = document.querySelector('#newDialog2 .el-dialog__header');
        }
     
        if(binding.value)
        {
          let dialog=document.querySelector('#' + binding.value);
          dragDom=document.querySelector('#' + binding.value + ' .el-dialog');
					
          dialogHeaderEl = document.querySelector('#' + binding.value + ' .el-dialog__header');
					
					//console.log('dragDom',binding.value,dragDom,dialogHeaderEl);
          //dialogHeaderEl = dragDom.querySelector('.el-dialog__header');

          //dialogHeaderEl = dialog.querySelector('.el-dialog__header');
          //dragDom = dialog.querySelector('.el-dialog');
        }
        //console.log('dialogHeaderEl',dialogHeaderEl)
        setTimeout(()=>{
          //console.log(dragDom.offsetHeight,dragDom.offsetWidth);
          if(dragDom)
          {
            beginHeight=dragDom.offsetHeight;
            beginWidth=dragDom.offsetWidth;
            //console.log('beginHeight',beginHeight,dragDom);

            if(dragDom.offsetHeight>minHeight)
            {
              //minHeight=dragDom.offsetHeight;

              let mxDom=dragDom.querySelectorAll('.mingxi-list');
              //console.log(mxDom)
              if(mxDom){
                offsetHeight=dragDom.offsetHeight - beginHeight;

                //console.log(dragDom.offsetHeight,beginHeight,offsetHeight);
                //console.log(dragDom.querySelector('.mingxi-list').offsetHeight,offsetHeight);
                mxDom.forEach((item,index)=>{
                  if(item.offsetHeight>0){
                    minMingxiHeight=item.offsetHeight;

                    let h=item.offsetHeight + offsetHeight;

                    if(h<240) h=240;

                    offsetHeight=dragDom.offsetHeight - beginHeight

                    item.style.height=h + 'px';

                    store.state.mingxiHeight=h;

                    //console.log(index, h, item.offsetHeight, offsetHeight)
                  }

                })

              }
            }
            if(dragDom.offsetWidth>minWidth)
            {
              //minWidth=dragDom.offsetWidth;
            }
            beginWidth = dragDom.offsetWidth;
            beginHeight = dragDom.offsetHeight;
          }
        },200);

        //给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
        //dragDom.style.overflow = "auto";

        //清除选择头部文字效果
        //dialogHeaderEl.onselectstart = new Function("return false");

        //头部加上可拖动cursor
        if(dialogHeaderEl){
          dialogHeaderEl.style.cursor = 'move';

          // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
          const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null);

          let moveDown = (e) => {

              // 鼠标按下，计算当前元素距离可视区的距离
              let disX = e.clientX - dialogHeaderEl.offsetLeft;
              let disY = e.clientY - dialogHeaderEl.offsetTop;

              // 获取到的值带px 正则匹配替换
              let styL, styT;

              // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
              if (sty.left.includes('%')) {
                  styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100);
                  styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100);
              } else {
                  styL = +sty.left.replace(/\px/g, '');
                  styT = +sty.top.replace(/\px/g, '');
              };
							
							
              document.onmousemove = function (e) {
								//console.log('dragDom2',document.body.clientHeight,e.clientY,nowWidth);
                  // 通过事件委托，计算移动的距离
                  let l = e.clientX - disX + styL;
                  let t = e.clientY - disY + styT;
									
									if(l>=document.body.clientWidth-20){
										l=document.body.clientWidth-20;
									}
									if(t<0){
										t=0;
									}
									else if(t>=document.body.clientHeight-20){
										t=document.body.clientHeight-20;
									}
									//console.log('l:',l,'t:',t,'clientWidth:',document.body.clientWidth,'clientHeight:',document.body.clientHeight);
									
                  // 移动当前元素
                  dragDom.style.left = `${l}px`;
                  dragDom.style.top = `${t}px`;

                  //将此时的位置传出去
                  //binding.value({x:e.pageX,y:e.pageY})
              };
              document.onmouseup = function (e) {
                  document.onmousemove = null;
                  document.onmouseup = null;
              };
          }

          dialogHeaderEl.onmousedown = moveDown;

          //双击头部全屏效果
          dialogHeaderEl.ondblclick = (e) => {
              return;
              if (isFullScreen == false) {

                  nowHight = dragDom.clientHeight;

                  nowWidth = dragDom.clientWidth;

                  nowMarginTop = dragDom.style.marginTop;

                  nowLeft=dragDom.style.left;
                  nowTop=dragDom.style.top;
                  //console.log('放大',nowLeft,nowTop);

                  dragDom.style.left = 0;
                  dragDom.style.top = 0;

                  dragDom.style.height = "100VH";
                  dragDom.style.width = "100VW";

                  dragDom.style.marginTop = 0;
                  isFullScreen = true;

                  dialogHeaderEl.style.cursor = 'initial';
                  dialogHeaderEl.onmousedown = null;

                  setTimeout(()=>{
                    let mxDom=dragDom.querySelectorAll('.mingxi-list');

                    if(mxDom){
                      offsetHeight=dragDom.offsetHeight - beginHeight;
                      if(offsetHeight>35){
                        offsetHeight=offsetHeight-35;
                      }
                      //console.log(dragDom.offsetHeight,nowHight);
                      //console.log(dragDom.querySelector('.mingxi-list').offsetHeight,offsetHeight);
                      mxDom.forEach((item,index)=>{
                        if(item.offsetHeight>0){
                          let h=item.offsetHeight + offsetHeight;

                          if(h<440) h=440;

                          item.style.height=h + 'px';

                          store.state.mingxiHeight=h;

                          //console.log('false',index, h, item.offsetHeight, offsetHeight)
                        }
                      })

                    }

                  },50);
              } else {

                  dragDom.style.height = "auto";
                  dragDom.style.width = beginWidth + 'px';
                  dragDom.style.marginTop = nowMarginTop;
                  //console.log('还原',nowLeft,nowTop);
                  dragDom.style.left= nowLeft;
                  dragDom.style.top= nowTop;

                  isFullScreen = false;
                  dialogHeaderEl.style.cursor = 'move';
                  dialogHeaderEl.onmousedown = moveDown;

                  setTimeout(()=>{
                    let mxDom=dragDom.querySelectorAll('.mingxi-list');

                    if(mxDom){
                      offsetHeight= beginHeight - dragDom.offsetHeight;

                      //console.log(dragDom.offsetHeight,nowHight);
                      //console.log(dragDom.querySelector('.mingxi-list').offsetHeight,offsetHeight);
                      mxDom.forEach((item,index)=>{
                        if(item.offsetHeight>0){
                          let h=item.offsetHeight + offsetHeight;

                          if(h<440) h=440;

                          item.style.height=h + 'px';

                          store.state.mingxiHeight=h;

                          //console.log('true',index, h, item.offsetHeight, offsetHeight)
                        }
                      })

                    }
                  },50);
              }
          }
        }

        if(dragDom){
          dragDom.onmousemove = function (e) {

              let moveE = e;

              dragDom.onmousedown = (e) => {

                  const clientX = e.clientX;
                  const clientY = e.clientY;

                  let elW = dragDom.clientWidth;
                  let elH = dragDom.clientHeight;

                  let EloffsetLeft = dragDom.offsetLeft;
                  let EloffsetTop = dragDom.offsetTop;

                  dragDom.style.userSelect = 'none';

                  let ELscrollTop = el.scrollTop;

                  //判断点击的位置是不是为头部

                  if (clientX > EloffsetLeft && clientX < EloffsetLeft + elW && clientY > EloffsetTop && clientY < EloffsetTop + 100) {

                      //如果是头部在此就不做任何动作，以上有绑定dialogHeaderEl.onmousedown = moveDown;

                  }else{

                      document.onmousemove = function (e) {

                          e.preventDefault(); // 移动时禁用默认事件

                          //左侧鼠标拖拽位置
                          if (clientX > EloffsetLeft && clientX < EloffsetLeft + 10) {
                              //往左拖拽
                              if (clientX > e.clientX) {
                                  dragDom.style.width = elW + (clientX - e.clientX) * 1 + 'px';
                                  dragDom.style.left = EloffsetLeft - (clientX - e.clientX) * 1 + 'px';
                              }
                              //往右拖拽
                              if (clientX < e.clientX) {
                                  if(dragDom.clientWidth < minWidth){

                                  }else{
                                      dragDom.style.width = elW - (e.clientX - clientX) * 1 + 'px';
                                      dragDom.style.left = EloffsetLeft + (e.clientX - clientX )  + 'px';  //2022-11-23
                                     //console.log('clientX',clientX);
                                     //console.log('e.clientX',e.clientX);
                                  }
                              }
                          }
                          //右侧鼠标拖拽位置
                          if (clientX > EloffsetLeft + elW - 10 && clientX < EloffsetLeft + elW) {

                              //往左拖拽
                              if (clientX > e.clientX) {
                                  if (dragDom.clientWidth < minWidth) {

                                  } else {
                                      dragDom.style.width = elW - (clientX - e.clientX) * 1 + 'px';
                                  }
                              }
                              //往右拖拽
                              if (clientX < e.clientX) {
                                  dragDom.style.width = elW + (e.clientX - clientX) * 1 + 'px';
                              }
                          }
                          //底部鼠标拖拽位置
                          if (ELscrollTop + clientY > EloffsetTop + elH - 20 && ELscrollTop + clientY < EloffsetTop + elH) {
                            return;
                              //往上拖拽
                              if (clientY > e.clientY) {
                                  if (dragDom.clientHeight < minHeight) {
                                    store.state.mingxiHeight=minHeight;


                                  } else {
                                    dragDom.style.height = beginHeight - (clientY - e.clientY) * 1 + 'px';

                                    offsetHeight=dragDom.offsetHeight - beginHeight;

                                    let h=minMingxiHeight + offsetHeight;
                                    store.state.mingxiHeight=h;

                                  }
                              }

                              //往下拖拽

                              if (clientY < e.clientY) {
                                  dragDom.style.height = beginHeight + (e.clientY - clientY) * 1 + 'px';

                                  offsetHeight=dragDom.offsetHeight - beginHeight;

                                  let h=minMingxiHeight + offsetHeight;
                                  store.state.mingxiHeight=h;
                              }

                              //console.log(store.state.mingxiHeight);
                          }
                      };

                      //拉伸结束
                      document.onmouseup = function (e) {
                          document.onmousemove = null;
                          document.onmouseup = null;
                      };
                  }
              }
              //console.log(e.clientX,dragDom.offsetLeft + dragDom.clientWidth - 10,dragDom.offsetLeft + 10)
              if (e.clientX > dragDom.offsetLeft + dragDom.clientWidth - 10 || dragDom.offsetLeft + 10 > e.clientX) {

                  dragDom.style.cursor = 'w-resize';

              } else if (el.scrollTop + e.clientY > dragDom.offsetTop + dragDom.clientHeight - 10) {

                  dragDom.style.cursor = 's-resize';

              } else {
                  //dragDom.style.cursor = 'default';
                  dragDom.style.cursor = '';
                  dragDom.onmousedown = null;
              }

          }
        }
    }
})
